import { getComponentsStyles } from '../commons/components/styles';
import { FONT_FAMILY } from '../config/flame/text';
import { getFont } from '../config/font';
import { getShadow } from '../config/shadow';
import { animations } from './animations/animations';
import { FLAME_PRIVATE_LIGHT_REGULAR_BASE_STYLES } from './baseStyles';
import { flamePrivateLightRegular as FOUNDATIONS_STYLES } from './flamePrivateLightRegular';
const SHADOWS = getShadow(FOUNDATIONS_STYLES);
const FONT_STYLES = getFont(FOUNDATIONS_STYLES);
const getFilteredComponentsStyles = (filter) => ({
    ...getComponentsStyles({
        FOUNDATIONS: FOUNDATIONS_STYLES,
        FONT: FONT_STYLES,
        ANIMATIONS: animations,
        FONT_FAMILY,
        SHADOWS,
        filter,
    }),
});
export const FLAME_PRIVATE_LIGHT_REGULAR_STYLES = {
    ...getFilteredComponentsStyles(),
    ...FLAME_PRIVATE_LIGHT_REGULAR_BASE_STYLES,
};
export const FLAME_PRIVATE_LIGHT_REGULAR_STYLES_FILTER = (filter) => ({
    ...getFilteredComponentsStyles(filter),
    ...FLAME_PRIVATE_LIGHT_REGULAR_BASE_STYLES,
});
//# sourceMappingURL=styles.js.map